import { ExportPowerBIReportFileFormat } from '@power-bi/models/export-power-bi-report-file-format';

export const EXPORT_POWER_BI_REPORT_FILE_DOWNLOAD_FORMAT_OPTIONS = [
  {
    name: 'PDF',
    description: '.pdf',
    value: ExportPowerBIReportFileFormat.PDF,
    icon: 'file-pdf'
  },
  {
    name: 'PowerPoint',
    description: '.pptx',
    value: ExportPowerBIReportFileFormat.PPTX,
    icon: 'file-powerpoint'
  },
  {
    name: 'Image',
    description: '.png',
    value: ExportPowerBIReportFileFormat.PNG,
    icon: 'file-png'
  }
];
